<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <div class="header accent p-24 h-160" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="column" fxLayoutAlign="center start">
            <div class="h1 mt-16">{{ getUserData().firstName }} {{ getUserData().lastName }}</div>
            <div class="h2 mt-16">E-mail: {{ getUserData().email }}</div>
            <div class="h3 mt-16">Phone: {{ getUserData().phone }}</div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">
<!--        <p>-->
<!--            <b>Card number: </b>-->
<!--            {{ getUserData().cardNumber }}-->
<!--        </p>-->
        <div class="h4 mt-16">Address</div>
        <p>
            {{ getUserData().street }} {{ getUserData().houseNumber }}<span *ngIf="getUserData().flatNumber.length>0">/{{ getUserData().flatNumber }}</span><br/>
            {{ getUserData().postCode }} {{ getUserData().city }}<br/>
            {{ getUserData().country }}<br/>
        </p>
    </div>
</div>
